type clearLocalStorageProps = {
  exclude?: string[];
  include?: string[];
};
export function clearLocalStorage(props: clearLocalStorageProps = {}) {
  const { exclude = [], include = ['*'] } = props;
  const keysList = Object.keys(localStorage);
  keysList.forEach((key) => {
    if (exclude.some((pattern) => new RegExp(pattern.replace(/^\*/g, '.*')).test(key))) {
      return;
    }
    if (include.some((pattern) => new RegExp(pattern.replace(/^\*/g, '.*')).test(key))) {
      localStorage.removeItem(key);
    }
  });
}
